import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import ChallengeCompletedIcon from '../../assets/images/challenge-completed.svg';
import * as styles from './ChallengeCardCompleted.css';

const cx = classNames.bind(styles);

const ChallengeCardCompleted = ({ challenge, onDetailsClick }) => {
    const { shortDescription, description } = challenge;

    return (
        <div className={cx('challengeCard')}>
            <div className={cx('titleRow')}>
                <span className={cx('iconWrapper')}>
                    <Icon iconType="svg" width="20px" height="20px" viewBox="0 0 20 20">
                        <ChallengeCompletedIcon />
                    </Icon>
                </span>
                <span className={cx('title')}>{description}</span>
                <button
                    type="button"
                    className={cx('detailsLink')}
                    onClick={() => onDetailsClick(challenge)}
                >
                    Details
                </button>
            </div>
            <p className={cx('earnValue')}>+{shortDescription} earned</p>
        </div>
    );
};

ChallengeCardCompleted.propTypes = {
    challenge: PropTypes.shape({
        offerId: PropTypes.string,
        shortDescription: PropTypes.string,
        description: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        offerTermsAndConditions: PropTypes.string,
    }).isRequired,
    onDetailsClick: PropTypes.func.isRequired,
};

export default ChallengeCardCompleted;
